import { createContext, useEffect, useState } from 'react';
import { Group, GroupsResponse, GroupResponse, CountriesResponse, Country, Resource, ResourceResponse, UserResponse, UsersResponse, User } from '../../models/interfaces';
import topApi from '../../components/api/ToPApi';




type GroupsContextProps = {
    isLoading: boolean;
    groups: Group[];
    totalPage: number;
    loadGroups: (page: number) => Promise<void>;
    addGroup: (group: Group) => Promise<string>;
    updateGroup: (group: Group) => Promise<string>;
    deleteGroup: (id: number) => Promise<string>;
    loadResources: () => Promise<Resource[]>;
    loadGroupResources: (id: number) => Promise<Resource[]>;
    saveGroupResources: (payload: any) => Promise<string>;
    loadUsers: () => Promise<User[]>;
    loadGroupUsers: (group_id: number) => Promise<User[]>;
    saveGroupUsers: (payload: any) => Promise<string>;



}



export const GroupsContext = createContext({} as GroupsContextProps);

export const GroupsProvider = ({ children }: any) => {

    const [groups, setGroups] = useState<Group[]>([]);
    const [countries, setCountries] = useState<Country[]>([]);
    const [totalPage, setTotalPage] = useState<number>(0);
    const pageSize = 25;
    const [isLoading, setIsloading] = useState<boolean>(false);





    const loadGroups = async (pageActual) => {
        setIsloading(true);
        try {
            const resp = await topApi.get<GroupsResponse>('/group/getGroups');
            if (resp.status == 200) {
                setGroups([...resp.data.groups]);
                setTotalPage(1);
            }
        } catch (error) {

        } finally {
            setIsloading(false)
        }


    }



    const addGroup = async (group: Group) => {
        try {
            group.group_id = undefined;
            const resp = await topApi.post<GroupResponse>('/group/', { group });
            setGroups([...groups, resp.data.group]);
            return 'success'

        } catch (e) {
            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";
        }
    }


    const updateGroup = async (group: Group) => {
        try {
            const resp = await topApi.put<Group>(`/group/${group.group_id}`, { group });

            setGroups(groups.map(prod => {
                return (prod.group_id === group.group_id)
                    ? resp.data["group"]
                    : prod;
            }));

            return 'success'

        } catch (e) {
            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";
        }


    }

    const deleteGroup = async (id: number) => {
        try {
            await topApi.delete<Group>(`/group/${id}`);
            setGroups((prevGroups) =>
                prevGroups.filter((group) => group.group_id! !== id)
            );
            return 'success'
        } catch (e) {
            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";
        }
    }

    const loadResources = async () => {

        const resp = await topApi.get<ResourceResponse>('/security/getResources');
        if (resp.status == 200) {
            return resp.data.resources;
        } else {
            return [];
        }
    }

    const loadGroupResources = async (groupId: number) => {

        const resp = await topApi.get<ResourceResponse>('/group/getPermissionByGroup/' + groupId);
        if (resp.status == 200) {
            return resp.data.resources;
        } else {
            return [];
        }
    }

    const saveGroupResources = async (payload: any) => {
        try {
            const resp = await topApi.post<GroupResponse>('/group/savePermissionByGroup', payload);
            return 'success'

        } catch (e) {
            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";
        }
    }

    const loadUsers = async () => {

        const resp = await topApi.get<UsersResponse>('/user/getUsersByFI');
        if (resp.status == 200) {
            return resp.data.users;
        } else {
            return [];
        }
    }

    const loadGroupUsers = async (groupId: number) => {

        const resp = await topApi.get<UsersResponse>('/group/getUserByGroup/' + groupId);
        if (resp.status == 200) {
            return resp.data.users;
        } else {
            return [];
        }
    }

    const saveGroupUsers = async (payload: any) => {
        try {
            const resp = await topApi.post<GroupResponse>('/group/saveUserByGroup', payload);
            return 'success'

        } catch (e) {
            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";
        }
    }





    return (
        <GroupsContext.Provider value={{
            isLoading, groups, totalPage, loadGroups, addGroup, updateGroup, deleteGroup,
            loadResources, loadGroupResources, saveGroupResources, loadUsers, loadGroupUsers, saveGroupUsers
        }}>
            {children}
        </GroupsContext.Provider>
    );
}